<template>
  <div>
    <div class="tips">
      <img src="@/assets/img/asterisk_red.png" alt=""/>{{$t('infoTip')}}
    </div>
    <div class="tip-line"></div>
    <van-form ref="myForm">
      <!-- 活动 -->
      <van-collapse :class="$i18n.locale" v-model="activeNames" v-if="activityPlan && activityPlan.length">
        <van-collapse-item :title="key.replace(/(.*)<<.*?\]\]$/, '$1')" v-for="(value, key, idx) in activities" :key="idx" :name="idx">
          <van-field name="checkboxGroup">
            <template #input>
              <van-checkbox-group v-model="checkboxGroup[idx]" @change="checkChange">
                <van-checkbox :name="index" shape="square" v-for="(item, index) in value" :key="index">
                  <div class="title">{{$t1(item, 'name')}}</div>
                  <div class="time"><img src="@/assets/img/clockImg.svg" alt=""/>{{item.startTime + '-' + item.endTime}}</div>
                  <div class="address"><img src="@/assets/img/address.png" alt=""/>{{$t1(item, 'placeName')}}</div>
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
        </van-collapse-item>
      </van-collapse>
      <!-- 专访 -->
      <van-collapse :class="$i18n.locale" v-model="activeNames1" v-if="interviewPlan && interviewPlan.length">
        <van-collapse-item :title="key" v-for="(value, key, idx) in activities1" :key="idx" :name="idx">
          <van-field name="checkboxGroup1">
            <template #input>
              <van-checkbox-group v-model="checkboxGroup1[idx]" @change="checkChange1">
                <van-checkbox :name="index" shape="square" v-for="(item, index) in value" :key="index">
                  <div class="title">{{$t1(item, 'name')}}</div>
                  <div class="time"><img src="@/assets/img/clockImg.svg" alt=""/>{{item.startTime + '-' + item.endTime}}</div>
                  <div class="address"><img src="@/assets/img/address.png" alt=""/>{{$t1(item, 'placeName')}}</div>
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
        </van-collapse-item>
      </van-collapse>
    </van-form>
  </div>
</template>

<script>

import { objectMergLeft } from '@/utils'
import { getActivityAll } from '@/api/activity'
import { getInterviewAll } from '@/api/interview'
import { mapGetters } from 'vuex'

const tmpForm = {
  id: undefined,
  wantRecord: undefined,
  wantInterview: undefined
}

export default {
  name: 'activityInte',
  data () {
    return {
      form: {},
      activeNames: [0],
      checkboxGroup: [],
      activities: {},
      activityKeyDict: [],
      activityValueDict: {},
      activeNames1: [],
      checkboxGroup1: [],
      activities1: {},
      activityKeyDict1: [],
      activityValueDict1: {}
    }
  },
  computed: {
    ...mapGetters(['activityPlan', 'interviewPlan'])
  },
  mounted () {
    if (this.activityPlan && this.activityPlan.length) {
      this.getActivityAll()
    } else {
      this.activeNames1 = [0]
    }
    if (this.interviewPlan && this.interviewPlan.length) {
      this.getInterviewAll()
    }
  },
  methods: {
    initForm (form) {
      this.form = Object.assign({}, tmpForm)
      objectMergLeft(this.form, form)
      // 反显活动
      this.checkboxGroup = this.checkboxGroup.map(() => [])
      if (this.form.wantRecord) {
        const keyList = this.form.wantRecord.split(',')
        for (const key of keyList) {
          const value = this.activityValueDict[key]
          if (value && this.checkboxGroup[value[0]]) {
            this.checkboxGroup[value[0]].push(parseInt(value[1]))
          }
        }
      }
      // 反显专访
      this.checkboxGroup1 = this.checkboxGroup1.map(() => [])
      if (this.form.wantInterview) {
        const keyList = this.form.wantInterview.split(',')
        for (const key of keyList) {
          const value = this.activityValueDict1[key]
          if (value && this.checkboxGroup1[value[0]]) {
            this.checkboxGroup1[value[0]].push(parseInt(value[1]))
          }
        }
      }
    },
    validate () {
      return this.$refs.myForm.validate()
    },
    getActivityAll () {
      getActivityAll({ conferenceId: this.$route.params.conferenceId, activityIds: this.activityPlan }).then(res=> {
        this.activities = res.data
        this.checkboxGroup = []
        this.activityKeyDict = []
        Object.keys(this.activities).forEach((x, i) => {
          this.checkboxGroup.push([])
          const tmpList = []
          for (const j in this.activities[x]) {
            const activity = this.activities[x][j]
            tmpList.push(activity.id)
            this.activityValueDict[activity.id] = [i, j]
          }
          this.activityKeyDict.push(tmpList)
        })
      })
    },
    checkChange () {
      this.form.wantRecord = ''
      const tmpActivities = []
      for (const i in this.checkboxGroup) {
        if (this.checkboxGroup[i] && this.checkboxGroup[i].length) {
          for (const j in this.checkboxGroup[i]) {
            tmpActivities.push(this.activityKeyDict[i][this.checkboxGroup[i][j]])
          }
        }
      }
      this.form.wantRecord = tmpActivities.join()
    },
    getInterviewAll () {
      getInterviewAll({ conferenceId: this.$route.params.conferenceId, interviewIds: this.interviewPlan }).then(res=> {
        this.activities1 = res.data
        this.checkboxGroup1 = []
        this.activityKeyDict1 = []
        Object.keys(this.activities1).forEach((x, i) => {
          this.checkboxGroup1.push([])
          const tmpList = []
          for (const j in this.activities1[x]) {
            const activity = this.activities1[x][j]
            tmpList.push(activity.id)
            this.activityValueDict1[activity.id] = [i, j]
          }
          this.activityKeyDict1.push(tmpList)
        })
      })
    },
    checkChange1 () {
      this.form.wantInterview = ''
      const tmpActivities = []
      for (const i in this.checkboxGroup1) {
        if (this.checkboxGroup1[i] && this.checkboxGroup1[i].length) {
          for (const j in this.checkboxGroup1[i]) {
            tmpActivities.push(this.activityKeyDict1[i][this.checkboxGroup1[i][j]])
          }
        }
      }
      this.form.wantInterview = tmpActivities.join()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: calc(100vh - 157px);
  margin: 0 0 -60px;
  background: #F2F4F6;
  // overflow-y: auto;
}
</style>